var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('AppHeader',{attrs:{"title":_vm.$t('Title') + ' ' + _vm.getMemberFormattedNameById(_vm.$route.query.member)}},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-auto"},[_c('ButtonExport',{attrs:{"label":_vm.$t('Export')},on:{"click":function($event){_vm.exportToExcel()}}})],1)])]),_c('AppContainer',[_c('BaseTabs',{attrs:{"slot":"left"},slot:"left"},[_c('BaseTab',{attrs:{"to":{
          name: 'Availability-Global',
          query: _vm.$route.query
        },"label":"Global"}}),_c('BaseTab',{attrs:{"to":{
          name: 'Availability-Details',
          params: { chargeToId: 1 },
          query: _vm.$route.query
        },"label":_vm.$t('OtherOrVaries')}}),_c('BaseTab',{attrs:{"to":{
          name: 'Availability-Details',
          params: { chargeToId: 18 },
          query: _vm.$route.query
        },"label":_vm.$t('InternalFormation')}})],1),_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }